import React, { useState, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";

import arrow1 from "../../assets/images/icon/arrow-1.svg";
import ApplicantChart from "./ApplicantChart";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { Trans, useTranslation } from "react-i18next";

export default function VacancyTable2() {
  const { t } = useTranslation();
  const products = [
    {
      id: 1,
      JobTitle: "Shift Managers",
      New: "0",
      UnderAssessment: "10",
      Selected: "10",
      Onboard: "10",
      OnHold: "10",
    },
    {
      id: 2,
      JobTitle: "Assistant Restaurant Managers",
      New: "0",
      UnderAssessment: "10",
      Selected: "10",
      Onboard: "10",
      OnHold: "10",
    },
    {
      id: 3,
      JobTitle: "Restaurant General Managers",
      New: "0",
      UnderAssessment: "10",
      Selected: "10",
      Onboard: "10",
      OnHold: "10",
    },
    {
      id: 4,
      JobTitle: "Developmental Roles",
      New: "0",
      UnderAssessment: "10",
      Selected: "10",
      Onboard: "10",
      OnHold: "10",
    },
    {
      id: 5,
      JobTitle: "Area Coach ",
      New: "0",
      UnderAssessment: "10",
      Selected: "10",
      Onboard: "10",
      OnHold: "10",
    },
  ];

  const columns = [
    {
      dataField: "id",
      text: "ID",
      classes: "total text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "JobTitle",
      text: "JobTitle",
      classes: "job-title pendinguser-cardss text-left white-space-nowrap",
      headerClasses: "pendinguser-cardss text-left white-space-nowrap",
    },
    {
      dataField: "New",
      text: "Readiness Form ",
      classes: "pending text-center  pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "UnderAssessment",
      text: "R3 (Selection Board) ",
      classes: "under-assessment text-center pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "Selected",
      text: "R2 (Training) ",
      classes: "selected-number text-cente pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "Onboard",
      text: "R1 (Selected)",
      classes: "on-board text-center pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "OnHold",
      text: "Internal Development",
      classes: "on-hold text-center pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
  ];

  const paginationOptions = {
    sizePerPage: 3, // Show 3 rows per page
    hideSizePerPage: false, // Show the dropdown to change page size
    showTotal: true, // Show total entries
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Dashboard.Showing rows`, { from, to, size })}
    </span>
  );

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div className="vacancy-tabel timetohires  vacancytables">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="eligible-content">
                <h3 className="d-flex align-items-center gap-2 heading-one">
                  Application Per Job
                </h3>

                <div className="vacancy-table-row d-flex gap-2">
                  <div className="tale-text right-panel">
                    <button
                      className="button left"
                      onClick={() => handleScroll("left")}
                      data-tooltip="Scroll Left"
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                    <button
                      className="button right"
                      onClick={() => handleScroll("right")}
                      data-tooltip="Scroll Right"
                    >
                      <img src={right_arrow} alt="right arrow 1" />
                    </button>
                  </div>

                  <h6 className="d-flex gap-3"></h6>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="tabel-application tabel-application-auto table-responsive minimum-height-card pb-3  center-content-s">
                <div className="timeto-hire-card userlist">
                  <div className="table-custome-class range-custome">
                    <div className="scroll-container">
                      <div className="table-pending-list">
                        <div className="table-wrapper" ref={tableWrapperRef}>
                          <BootstrapTable
                            keyField="id"
                            data={products}
                            columns={columns}
                            pagination={paginationFactory(options)}
                            striped
                            hover
                            rowClasses={rowClasses}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
